import React, { useState } from 'react';

interface BasalEntryFormProps {
  onSave: (entryData: any) => Promise<void>;
  onCancel: () => void;
  initialData?: any;
}

const BasalEntryForm: React.FC<BasalEntryFormProps> = ({ onSave, onCancel, initialData }) => {
  const [insulinUnits, setInsulinUnits] = useState<string>(initialData?.insulin_units?.toString() || '');
  const [insulinType, setInsulinType] = useState<string>(initialData?.insulin_type || 'Lantus');
  const [injectionSite, setInjectionSite] = useState<string>(initialData?.injection_site || '');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      await onSave({
        insulin_units: parseFloat(insulinUnits) || 0,
        insulin_type: insulinType,
        injection_site: injectionSite || null,
      });
    } catch (err) {
      console.error('Failed to save basal entry', err);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="entry-form popup-form">
      <h3>{initialData ? 'Edit Basal Entry' : 'New Basal Entry'}</h3>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label>Insulin Units</label>
          <input 
            type="number" 
            step="0.5" 
            value={insulinUnits} 
            onChange={e => setInsulinUnits(e.target.value)} 
            required 
            placeholder="0.0"
          />
        </div>
        <div className="form-group">
          <label>Insulin Type</label>
          <select value={insulinType} onChange={e => setInsulinType(e.target.value)}>
            <option value="Lantus">Lantus</option>
            <option value="Levemir">Levemir</option>
            <option value="Tresiba">Tresiba</option>
            <option value="Basaglar">Basaglar</option>
            <option value="Toujeo">Toujeo</option>
          </select>
        </div>
        <div className="form-group">
          <label>Injection Site</label>
          <input 
            type="text" 
            value={injectionSite} 
            onChange={e => setInjectionSite(e.target.value)} 
            placeholder="e.g. Right Arm"
          />
        </div>
        <div className="form-actions" style={{ display: 'flex', gap: '1rem', marginTop: '1.5rem' }}>
          <button type="button" className="btn-secondary" onClick={onCancel} disabled={isSubmitting}>Cancel</button>
          <button type="submit" className="btn-primary" disabled={isSubmitting}>
            {isSubmitting ? 'Saving...' : 'Save Entry'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default BasalEntryForm;
